import request from '../utils/request';
import request1 from '../utils/request1';
import request2 from '../utils/request2';
import JSEncrypt from 'jsencrypt'
import url1 from '../utils/url'
var refresh_token=''
if(localStorage.getItem("token")){
   refresh_token = JSON.parse(localStorage.getItem("token")).refresh_token || ''  
}else{
  var token = {
    refresh_token:"",
    access_token:""
  }
  localStorage.setItem('token',JSON.stringify(token))
   refresh_token=''
}
var data = {
    client_id: "cms-client",
    client_secret: "cms-client",
    grant_type: "refresh_token",
    scope: "all",
    refresh_token:refresh_token
  }
  var RefreshToken = () => {
    httpGet(data, "/oauth/token").then((res) => {
      if (res.access_token) {
        localStorage.setItem("token", JSON.stringify(res));
      }
    })
  }
const httpGet = (query,url) => {
    return request({
        url: url1+url,
        method: "GET",
        params: query
    });
};
const httpPost = (query,url) => {
    return request({
        url: url1+url,
        method: "POST",
        data: query
    });
};
 function setCode(str,text){ // 注册方法
  let pubKey = str;// ES6 模板字符串 引用 rsa 公钥
  let encryptStr = new JSEncrypt();
  encryptStr.setPublicKey(pubKey); // 设置 加密公钥
  let  data = encryptStr.encrypt(text.toString());  // 进行加密
  return data;
}
const httpGet1 = (query,url) => {
    return request1({
        url: url1+url,
        method: "GET",
        params: query
    });
};
const httpPost1 = (query,url) => {
    return request2({
        url: url1+url,
        method: "POST",
        data: query
    });
};

const httpPostfrom = (query,url) => {
  return request1({
      url: url1+url,
      method: "POST",
      data: query
  });
};
export {httpGet,RefreshToken,httpPost,setCode,httpGet1,httpPost1,httpPostfrom}


// WEBPACK FOOTER //
// ./src/api/index.js